import Region from '../../../../../constants/region';
import { getUserRegion } from '../../../../../../utils';
import bongards from './bongards-nav-config';
import cacique from './cacique-nav-config';
import cdi from './cdi-nav-config';
import defaultConfig from './default-nav-config';
import demo from './demo-nav-config';
import imp from './imp-nav-config';
import legacy from './legacy-nav-config';
import minerva from './minerva-nav-config';
import mmpa from './mmpa-nav-config';
import nl from './nl-nav-config';
import plainview from './plainview-nav-config';
import prairie from './prairie-nav-config';
import psc from './psc-nav-config';
import tcjErie from './tcj-erie-nav-config';
import tcjGpda from './tcj-gpda-nav-config';
import tcjKytn from './tcj-kytn-nav-config';
import tcjLiberty from './tcj-liberty-nav-config';
import tcjNebraska from './tcj-nebraska-nav-config';
import tcjWhiteEagle from './tcj-whiteeagle-nav-config';
import uda from './uda-nav-config';
import udi from './udi-nav-config';
import unc from './unc-nav-config';

const navigationConfigs = {
    [Region.BONGARDS]: bongards,
    [Region.CACIQUE]: cacique,
    [Region.CDI]: cdi,
    [Region.DEMO]: demo,
    [Region.IMP]: imp,
    [Region.LEGACY]: legacy,
    [Region.MINERVA]: minerva,
    [Region.MMPA]: mmpa,
    [Region.NL]: nl,
    [Region.PLAINVIEW]: plainview,
    [Region.PRAIRIE]: prairie,
    [Region.PSC]: psc,
    [Region.TCJ.ERIE]: tcjErie,
    [Region.TCJ.GPDA]: tcjGpda,
    [Region.TCJ.KYTN]: tcjKytn,
    [Region.TCJ.LIBERTY]: tcjLiberty,
    [Region.TCJ.NEBRASKA]: tcjNebraska,
    [Region.TCJ.WHITEEAGLE]: tcjWhiteEagle,
    [Region.UDA]: uda,
    [Region.UDI]: udi,
    [Region.UNC]: unc,
};

const getNavigationConfig = () => {
    const region = getUserRegion();
    return Object.values(navigationConfigs[region] ?? defaultConfig);
};

export default getNavigationConfig;
